import { useEffect, useRef } from "react";

export default function ScrollProgress() {
  const barRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let docHeight = document.documentElement.scrollHeight - window.innerHeight;
    let ticking = false;

    const recalc = () => {
      docHeight = document.documentElement.scrollHeight - window.innerHeight;
    };

    const update = () => {
      ticking = false;
      if (!barRef.current || docHeight <= 0) return;
      const progress = Math.min(1, Math.max(0, window.scrollY / docHeight));
      barRef.current.style.transform = `scaleX(${progress})`;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", recalc, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", recalc);
    };
  }, []);

  return (
    <div
      ref={barRef}
      className="fixed top-0 left-0 right-0 h-[2px] bg-foreground/60 z-[60] origin-left"
      style={{ transform: "scaleX(0)", willChange: "transform" }}
      aria-hidden="true"
    />
  );
}
